import Vue from 'vue';
import VueI18n from 'vue-i18n'

import en from './en'
import zh from './zh'
 
Vue.use(VueI18n);
 
const messages = {
  en,
  zh
};

const i18n = new VueI18n({
  locale: 'zh',
  messages,
});
export function addI18n(moduleName, moduleMessage) {
  if (!moduleName) {
    return;
  }
  if (!moduleMessage) {
    return;
  }

  for (const lang_key in messages) {
    if (moduleMessage[lang_key]) {
      // 合并路由
      if (moduleMessage[lang_key]['route']) {
        // 合并路由信息
        messages[lang_key]['route'] = {
          ...messages[lang_key]['route'],
          ...moduleMessage[lang_key]['route']
        };
      }
      // 删除项目模块路由信息
      delete moduleMessage[lang_key]['route'];

      // 合并httpCode国际化提示信息
      if (moduleMessage[lang_key]['httpCode']) {
        // 合并
        messages[lang_key]['httpCode'] = {
          ...messages[lang_key]['httpCode'],
          ...moduleMessage[lang_key]['httpCode']
        };
      }
      // 删除项目模块httpCode信息
      delete moduleMessage[lang_key]['httpCode'];

      const newObject = Object.assign(messages[lang_key], moduleMessage[lang_key]);
      i18n.setLocaleMessage(lang_key, newObject);
    }
  }
}
export default i18n;